import React, { useEffect } from "react";
import "./FAQ.css";
import Accordion from "react-bootstrap/Accordion";

// Import AOS and its styles
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function FAQ() {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,  // Set animation duration
      easing: 'ease-out', // Easing type for smoother transitions
      once: true, // Animation happens once on scroll
    });
  }, []);

  return (
    <div className="FAQ" id="FAQ">
      <div className="overlay"></div>
      <div className="container">
        <h1 className="tknhead sss HeadingFont text-center" data-aos="fade-up">FAQ</h1>

        <div className="row justify-content-center">
          <div className="col-md-6">
            <Accordion defaultActiveKey="0" className="position-relative z-2">
              <Accordion.Item eventKey="1" data-aos="fade-up">
                <Accordion.Header> What is the IP Token Project? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    The IP Token is designed to provide early supporters with an opportunity to stake their tokens before the official listing. It offers a high Annual Percentage Yield (APY) advantage and aims to build a strong foundation for the token’s ecosystem.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="mt-3" data-aos="fade-up" data-aos-delay="200">
                <Accordion.Header> How can I participate in the presale? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    The presale for IP Token is live! You can participate by purchasing IP Tokens directly from the presale. Early supporters will have the chance to stake their tokens into the smart contract even before the official listing.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="mt-3" data-aos="fade-up" data-aos-delay="400">
                <Accordion.Header> What is the IP Token, and how can I use it? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    The IP Token is a utility token that powers the IP ecosystem. It will be used for staking, governance, and rewards within the platform. The token plays a crucial role in the decentralized finance ecosystem.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" className="mt-3" data-aos="fade-up" data-aos-delay="600">
                <Accordion.Header> Can I buy tokens during the presale? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    Yes, you can buy IP Tokens during the presale. This is your opportunity to secure IP Tokens at a favorable price before the official launch. Don't miss out on staking opportunities and early APY advantages.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5" className="mt-3" data-aos="fade-up" data-aos-delay="800">
                <Accordion.Header> When will I receive my tokens? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    You will receive your IP Tokens immediately after the presale ends. Tokens will be sent to your wallet, and you'll be able to start staking them for rewards right away.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6" className="mt-3" data-aos="fade-up" data-aos-delay="1000">
                <Accordion.Header> Can I stake my IP Tokens? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    Yes, you can stake your IP Tokens after purchasing them. Staking will allow you to earn attractive rewards in the form of high APY. Early stakers will benefit the most from this feature.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="7" className="mt-3" data-aos="fade-up" data-aos-delay="1200">
                <Accordion.Header> What happens after the liquidity add on Uniswap? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    After the liquidity add on Uniswap, the market for IP Tokens will be set up, and trading can begin. This is a key milestone in the project, ensuring liquidity and allowing users to buy, sell, and interact with IP Token.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="8" className="mt-3" data-aos="fade-up" data-aos-delay="1400">
                <Accordion.Header> When will the IP Token be listed on Uniswap? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    IP Token will be listed on Uniswap in Phase 3, which marks the DEX launch. The listing will provide a seamless trading experience for users and ensure accessibility to a global market. The launch price will be $0.0005.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="9" className="mt-3" data-aos="fade-up" data-aos-delay="1600">
                <Accordion.Header> What is the use case of IP Token? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    The IP Token will be used to interact with the DApps project on the Polygon Blockchain. It is essential for registration in the decentralized finance (DeFi) ecosystem, particularly for the MLM rewards system. The token will be used for various utility functions within the ecosystem.
                  </p>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="10" className="mt-3" data-aos="fade-up" data-aos-delay="1800">
                <Accordion.Header> What does the future hold for IP Token? </Accordion.Header>
                <Accordion.Body>
                  <p className="acc_para">
                    The future of IP Token is bright! The project aims to expand its ecosystem through innovative token use, enhanced community engagement, and further strategic partnerships. The journey will focus on token utility and positive contributions to the crypto space.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}
